
define('modules/application/wizard/classes/volumetricProtection',[
  "app",

  // Libs
  "backbone",

  // Classes
  "./genericCollectionSection"

],

function(app, Backbone, genericCollectionSection) {

  var eventsToBind          = _.extend({}, genericCollectionSection.genericCollectionItem.View.prototype.events);
  var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {
    View  : genericCollectionSection.genericCollectionItem.View.extend({
      tagName   : "li",
      className : "volumetricProtection",
      template  : "application/wizard/sections/genericCollectionSection/volumetricProtection",
      events    : _.extend(eventsToBind, {
        "change .type"                     :  "typeChangedEventHandler",
        "keyup input[name='description']"  :  "descriptionChangedEventHandler"
      }),
      initialize                      : function() {

        this.model.unbind("render:requested", this.render);
        this.model.bind("render:requested",   this.render, this);

        this.model.unbind("change:number",    this.render);
        this.model.bind("change:number",      this.render, this);
      },
      typeChangedEventHandler         : function(e) {
        var type = e.currentTarget.value;

        //Update the model
        this.model.set("type", type);
      },
      descriptionChangedEventHandler  : function(e) {
        this.model.set("description", e.currentTarget.value);
      }
    }),
    Model : genericCollectionSection.genericCollectionItem.Model.extend({
      defaults : {
        number      : -1,
        selected    : false,
        description : ""
      },

      initialize                              : function() {
        genericCollectionSection.genericCollectionItem.Model.prototype.initialize.apply(this);
        this.fetchPackages();

        this.unbind("change:type",  this.typeChangedEventHandler);
        this.bind("change:type",    this.typeChangedEventHandler, this);

        if (!this.get("type") && this.get("fetchedPackages").length>0)
          this.set("type", this.get("fetchedPackages")[0].packageClassId);
        else
          this.typeChangedEventHandler();

        if (this.get("partOfKit"))
          window.BticinoS4B.eventAggregator.trigger("connectToKit", this);
      },

      selectedStatusChangedEventHandler      : function() {
        if (this.get("selected"))
          this.get("collectionEventAggregator").trigger("selectedItem:changed", this);
        this.trigger("render:requested");
      },

      typeChangedEventHandler : function() {
        var type = this.get("type"), that = this;

        //Merging with wizard package attributes
        var wizardAttributes = _.filter(that.get("fetchedPackages"), function(pack) {
          return pack.packageClassId===type;
        });

        if (wizardAttributes.length===1)
          wizardAttributes = wizardAttributes[0];
        else
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(type, function(data){
            wizardAttributes = data;
          }, false);

        _.extend(this.attributes, wizardAttributes);

        //Merging with item's attributes
        if ((type)&&(type!=="")) {
          BticinoS4B.Instances.Models.ApplicationModel.getProducts(type, function(data) {
            data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
            var mainProduct       = _.filter(data.products,function(product) {return (product.mnemonic===1);})[0];
            var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

            _.extend(that.attributes, mainProduct);
            that.set("secondaryProducts", secondaryProducts);
          });
        }
        else {
          this.resetValues();
        }

        that.trigger("render:requested");
        window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
      },

      resetValues             : function() {
        this.set("catalogId",                undefined);
        this.set("description",              undefined);
        this.set("image",                    undefined);
        this.set("links",                    undefined);
        this.set("mnemonic",                 undefined);
        this.set("optionalPackages",         undefined);
        this.set("packageActuator",          undefined);
        this.set("packageClassId",           undefined);
        this.set("packageClassLabel",        undefined);
        this.set("packageInDepth",           undefined);
        this.set("packageLoad",              undefined);
        this.set("price",                    undefined);
        this.set("productCode",              undefined);
        this.set("productDescription",       undefined);
        this.set("productInDepth",           undefined);
        this.set("productLabel",             undefined);
        this.set("specialVars",              undefined);
        this.set("wizardChoiceDescription",  undefined);
        this.set("wizardChoiceLabel",        undefined);
        this.set("packageClassDescription",  undefined);
        this.set("packageClassId",           undefined);
        this.set("packageClassLabel",        undefined);
      },

      fetchPackages           : function() {
        if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
          var that = this;
          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(408, function(data) {
            that.set("fetchedPackages", data.packages);
          });
        }
      },

      deliverCurrent          : function() {
        if (this.get("specialVars")) {
          var consumptionIndicatorModel   = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
          var currentConsumption          = $.parseJSON(this.get("specialVars")).currentConsumption;
          if (currentConsumption<0)
            consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
          else
            consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
        }
      }
    })

  });

  var volumetricProtections             = _.extend({}, genericCollectionSection, {

    Views : {
      titleBar              : genericCollectionSection.Views.titleBar.extend(),
      content               : genericCollectionSection.Views.content.extend({
        template : "application/wizard/sections/genericCollectionSection/collectionWithInfo",
        events   : _.extend(_.extend({}, genericCollectionSection.Views.content.prototype.events), {
          "click .toggleInfoButton" : "toggleInfos"
        }),

        initialize : function() {
          genericCollectionSection.Views.content.prototype.initialize.apply(this);
          this.model.bind("item:removed",    this.itemRemovedEventHandler, this);
        },

        toggleInfos : function(e) {
          return genericCollectionSection.Views.content.prototype.toggleInfos(e, this);
        },
        addItemButtonClickedEventHandler       : function() {
          var collectionItemView  = genericCollectionItem.View;
          var elementToAdd        = this.model.addItem();
          if (elementToAdd) {
            var viewToAdd = new collectionItemView({model : elementToAdd});
            this.insertView(".elements", viewToAdd);
            this.$el.find(".alert").remove();
            viewToAdd.render();
          }
        },

        beforeRender                           : function() {
          var collection          = this.model.get("collection"), collectionLength = collection.models.length;
          var collectionItemView  = genericCollectionItem.View;
          var i=0;

          for (i=0; i<collectionLength; i++)
            this.insertView(".elements", new collectionItemView({model : collection.models[i]}));
        },

        afterRender                            : function() {
          if (this.model.get("collection").length===0)
            this.$el.append("<h4 class='alert'>"+$.i18n._("IDS_WAI1001_9018")+"</h4>");
          window.customizeFormElements.call();
        }

      })
    },

    Model                         : genericCollectionSection.Model.extend({
      defaults                        : _.extend({}, {
        name                   : "IDS_WAI8_8",
        collectionEventAggregator : _.extend({}, Backbone.Events),
        infoQuote              : "IDS_WGENTT_000022"
      },
      genericCollectionSection.Model.prototype.defaults),


      initialize                      : function() {
        genericCollectionSection.Model.prototype.initialize.apply(this);

        var collectionItemModel = genericCollectionItem.Model;
        var collectionModel     = Backbone.Collection.extend({model : collectionItemModel});
        var collection;
        var oldCollection, i=0;

        this.get("collectionEventAggregator").unbind("render:requested",         this.renderRequestedEventHandler);
        this.get("collectionEventAggregator").bind("render:requested",           this.renderRequestedEventHandler, this);

        //Perimetral protection zone events
        this.get("zoneEventAggregator").unbind("perimetralProtection:changed",this.perimetralProtectionChangedEventHandler);
        this.get("zoneEventAggregator").bind("perimetralProtection:changed",  this.perimetralProtectionChangedEventHandler, this);

        //Radio sensors zone events
        this.get("zoneEventAggregator").unbind("radioSensors:changed",        this.radioSensorsChangedEventHandler);
        this.get("zoneEventAggregator").bind("radioSensors:changed",          this.radioSensorsChangedEventHandler, this);

        //Lengths communication events
        this.get("zoneEventAggregator").unbind("communicate:lengths",         this.lengthsCommunicationRequested);
        this.get("zoneEventAggregator").bind("communicate:lengths",           this.lengthsCommunicationRequested, this);

        this.get("collectionEventAggregator").bind("selectedItem:changed",       this.selectedItemChangedEventHandler, this);

        window.BticinoS4B.eventAggregator.bind("zonesWithoutOneFreeVProtection:check",      this.addAvailability, this);

        // window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.deliverCurrent);
        // window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);

        if (this.get("collection")) {
          oldCollection  = this.get("collection");

          if (oldCollection.models)
            oldCollection = oldCollection.models;
        }

        this.set("collection", new collectionModel());
        collection      = this.get("collection");

        if (oldCollection) {
          for (i=0; i<oldCollection.length; i++) {
            if (!oldCollection[i].attributes)
              this.addItem(_.extend({
                collectionEventAggregator : this.get("collectionEventAggregator")
              }, oldCollection[i]));
            else
              collection.add(new collectionItemModel($.extend({}, oldCollection[i].attributes)));
          }
        }

        if (collection.length<this.get("minItem"))
          this.addItem();

        if((!this.get("radioSensorsLength"))||(!this.get("perimetralProtectionLength"))) {
          this.get("zoneEventAggregator").trigger("communicate:lengths");
        }

        this.sortItems();
      },

      addAvailability                             : function() {
        var zonesWithoutOneFreeVProtection = BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreeVProtection") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreeVProtection") : [];
        if (!this.isPossibleToAdd())
          zonesWithoutOneFreeVProtection.push(this.get("zoneNumber"));

        BticinoS4B.Instances.Models.ApplicationModel.set("zonesWithoutOneFreeVProtection", zonesWithoutOneFreeVProtection);
      },

      zoneNumberChangedEventHandler               : function(newZoneNumber) {
        var collection = this.get("collection");

        for (var i = collection.models.length - 1; i >= 0; i--)
          if (collection.models[i].get("kitsEventAggregator"))
            collection.models[i].get("kitsEventAggregator").trigger("zoneNumber:changed", newZoneNumber);
      },

      productAddedFromKitEventHandler             : function(addedVolumetricProtection) {
        for (var i = addedVolumetricProtection.quantity - 1; i >= 0; i--) {
          this.addItem({type : addedVolumetricProtection.packageClassId, generatedId : addedVolumetricProtection.generatedId, partOfKit : true, kitsEventAggregator : addedVolumetricProtection.kitsEventAggregator});
        }
        this.trigger("render:requested");
      },

      isRemovable                     : function() {
        var isRemovable= true,
            collection = this.get("collection");

        for (var i = collection.models.length - 1; i >= 0; i--) {
          isRemovable = collection.models[i].get("partOfKit") ? false : true;
        }

        return isRemovable;
      },

      lengthsCommunicationRequested   : function() {
        if (this.get("collection"))
          this.get("zoneEventAggregator").trigger("volumetricProtection:changed", this.get("collection").models.length);
        else
          this.get("zoneEventAggregator").trigger("volumetricProtection:changed", 0);
      },

      removeKitItem                              : function(itemToRemove) {
        var collection       = this.get("collection"),
            collectionLength = collection.length,
            i                = 0;

        for(i=0; i<collectionLength; i++)
        {
          if (collection.models[i].get("generatedId")===itemToRemove.generatedId)
          {
            this.removeItem(collection.models[i], true);
            break;
          }
        }

        this.trigger("updateViews");
        this.trigger("render:requested");
        this.sortItems();
      },

      removeKitItems                              : function() {
        var collection       = this.get("collection"),
            collectionLength = collection.length,
            i                = 0;

        for(i=0; i<collectionLength; i++)
        {
          if (collection.models[i].get("partOfKit"))
            this.removeItem(collection.models[i], true);
        }
        this.set("kitsEventAggregator", undefined);
        this.sortItems();
      },

      perimetralProtectionChangedEventHandler     : function(perimetralProtections) {
        this.set("perimetralProtectionLength", perimetralProtections);
      },

      radioSensorsChangedEventHandler             : function(radioSensors) {
        this.set("radioSensorsLength", radioSensors);
      },

      isPossibleToAdd                 : function() {
        var collection                 = this.get("collection"), collectionLength = collection.length;
        var perimetralProtectionLength = this.get("perimetralProtectionLength") ? this.get("perimetralProtectionLength") : 0;
        var radioSensorsLength         = this.get("radioSensorsLength")         ? this.get("radioSensorsLength")         : 0;
        return (collectionLength+perimetralProtectionLength+radioSensorsLength+1)<=this.get("maxItem");
      },

      addItem                         : function(itemModel) {
        var collection                 = this.get("collection"), collectionLength = collection.length;
        var defaultItem;
        //Per quando si cambiano i contatti dalla centrale
        this.get("collectionEventAggregator").unbind("duplication:requested", this.duplicationRequestedEventHandler);
        this.get("collectionEventAggregator").bind("duplication:requested", this.duplicationRequestedEventHandler, this);
        this.get("collectionEventAggregator").unbind("delete:requested", this.deleteRequestedEventHandler);
        this.get("collectionEventAggregator").bind("delete:requested", this.deleteRequestedEventHandler, this);

        if (this.isPossibleToAdd()) {
          var collectionItemModel = genericCollectionItem.Model;

          if (itemModel)
          {
            if (itemModel.partOfKit)
              defaultItem = new collectionItemModel(_.extend(itemModel, {zoneNumber : this.get("zoneNumber"), number : this.getNewNumber(), collectionEventAggregator : this.get("collectionEventAggregator")}));
            else
              defaultItem = new collectionItemModel(_.extend(itemModel, {zoneNumber : this.get("zoneNumber"), collectionEventAggregator : this.get("collectionEventAggregator")}));
          }
          else
            defaultItem = new collectionItemModel({zoneNumber : this.get("zoneNumber"), number : this.getNewNumber(), collectionEventAggregator : this.get("collectionEventAggregator")});

          var itemsToAdd        = [];
          itemsToAdd.push(defaultItem);
          genericCollectionSection.Model.prototype.addItem.apply(this, itemsToAdd);

          defaultItem.set("selected", true);

          this.trigger("updateViews", this.get("collection").length);
          //BticinoS4B.Instances.Models.ApplicationModel.set("volumetricProtectionLength", this.get("collection").models.length);
          this.get("zoneEventAggregator").trigger("volumetricProtection:changed", this.get("collection").models.length);

          //Trigger event for zone validation
          this.trigger("item:added");

          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

          return defaultItem;
        }
        else {
          alert($.i18n._('IDS_W1_9128'));
          return false;
        }
      },

      duplicateItem           : function(modelToDuplicate) {
        var collectionItemModel        = genericCollectionItem.Model;
        var itemNumber                 = this.getNewNumber();

        var collection                 = this.get("collection"), collectionLength = collection.length;
        var perimetralProtectionLength = this.get("perimetralProtectionLength") ? this.get("perimetralProtectionLength") : 0;
        var radioSensorsLength         = this.get("radioSensorsLength") ? this.get("radioSensorsLength") : 0;
        //Per quando si cambiano i contatti dalla centrale
        this.get("collectionEventAggregator").unbind("duplication:requested", this.duplicationRequestedEventHandler);
        this.get("collectionEventAggregator").bind("duplication:requested", this.duplicationRequestedEventHandler, this);
        this.get("collectionEventAggregator").unbind("delete:requested", this.deleteRequestedEventHandler);
        this.get("collectionEventAggregator").bind("delete:requested", this.deleteRequestedEventHandler, this);

        if (this.isPossibleToAdd())
        {
          if (modelToDuplicate)
          {
            modelToDuplicate = new collectionItemModel(modelToDuplicate.attributes);
            if (modelToDuplicate)
            {
              if (modelToDuplicate.get("partOfKit")!==undefined)
                modelToDuplicate.set("partOfKit", undefined);

              modelToDuplicate.set("number", itemNumber);
              this.get("collection").add(modelToDuplicate);
              this.trigger("updateViews", this.get("collection").length);
              //BticinoS4B.Instances.Models.ApplicationModel.set("volumetricProtectionLength", this.get("collection").models.length);
              this.get("zoneEventAggregator").trigger("volumetricProtection:changed", this.get("collection").models.length);

              //Trigger event for zone validation
              this.sortItems();
              this.trigger("item:added");
              this.trigger("render:requested");

              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              return modelToDuplicate;
            }
            else
              return false;
          }
          else
            return false;
        }
        else
        {
          alert($.i18n._('IDS_W1_9128'));
          return false;
        }
      },

      sortItems                       : function() {
        var collection = this.get("collection"), collectionLength = collection.length;
        var i=0;

        for (i=0; i<collectionLength; i++)
        {
          collection.models[i].set("number", (i+1));
          if (i===(collectionLength-1))
            collection.models[i].set("selected", true);
        }
      },

      removeSelectedItem              : function() {
        var selectedModels      = this.get("collection").filter(function(item){
          return item.get("selected");
        });

        return this.removeItem(selectedModels);
      },

      removeItem                      : function(modelToRemove, _silent) {
        var silent = false;

        if(_silent)
          silent= _silent;

        if (!modelToRemove.get("partOfKit") || silent)
        {
          if (this.deleteItem(modelToRemove, silent))
          {
            this.trigger("updateViews", this.get("collection").length);

            //BticinoS4B.Instances.Models.ApplicationModel.set("volumetricProtectionLength", this.get("collection").models.length);
            this.get("zoneEventAggregator").trigger("volumetricProtection:changed", this.get("collection").models.length);

            this.sortItems();

            //Trigger event for zone validation
            this.trigger("item:removed");
            this.trigger("render:requested");

            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

            return modelToRemove;
          }
        }
        else{
            alert($.i18n._('IDS_W1_9191'));
            return false;
          }
      },

      deliverCurrent                  : function() {
        var collection                  = this.get("collection"), collectionLength = collection.length;
        var consumptionIndicatorModel   = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
        var extraConsumption            = 30; //30 mA of extra consumption
        var mustDeliverExtraConsumption = false;
        var i=0;

        //Delivering regular consumptions
        for (i=0; i<collectionLength; i++)
        {
          if (collection.models[i].get("packageClassId") === "4044")
            mustDeliverExtraConsumption = true;
          collection.models[i].deliverCurrent();
        }

        if (mustDeliverExtraConsumption)
        {
          if (extraConsumption && extraConsumption!==0)
          {
            if ( extraConsumption < 0 )
              consumptionIndicatorModel.addSupplyCurrent(extraConsumption);
            else
              consumptionIndicatorModel.addCurrentConsumption(extraConsumption);
          }
        }

      }
    }),
    genericCollectionItem   : genericCollectionItem
  });

  // Required, return the module for AMD compliance
  return volumetricProtections;

});